<template>
  <div>
    <b-row>
      <b-col>
        <b-button variant="link" class="link"
          ><Visualizar /> Visualizar</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Visualizar from "../../image/icon/Visualizar.vue";
export default {
  components: {
    Visualizar,
  },
};
</script>

<style scoped>
.row {
  margin: 0;
  text-align: end;
}

.link {
  color: #052333;
  display: inline-flex;
  margin-bottom: 10px;
}

.link:hover {
  color: #052333;
}
</style>
